__turbopack_context__.v({
  "paragraphStyles": "L-SRxa_paragraphStyles",
});
